import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import OrderBand from "@/components/OrderBand";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyOrderBar from "@/components/StickyOrderBar";
import { Toaster } from "sonner";

export const scrollToSection = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <About />
        <Gallery />
        <OrderBand />
        <Contact />
      </main>
      <Footer />
      <StickyOrderBar />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
